module.exports = __webpack_public_path__ + "img/occupancy-detector-lg-vacant.eb75d314.svg";